import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface InterviewAuditStateProps {
  auditLogsHeartbeatStarted: boolean
  auditLogsCompleteData: any
  startEventId: string | null
}

const initialState: InterviewAuditStateProps = {
  auditLogsHeartbeatStarted: false,
  startEventId: null,
  auditLogsCompleteData: {
    event_id: "",
    widget_code: "",
    action_performed: null,
    payload: {
      seg_id: "segment_no",
      input_params_obj: {
        interview_domain: "interview_domain_na",
        candidate_level: null,
        interview_type: "technical",
        time_in_sec: 0,
        question_count: 5,
        difficulty_progression: "adaptive",
        include_coding: false,
        interviewer_persona: "professional",
        consider_history: true,
        custom_instructions: "custom_instructions_na",
        rubric_criteria: ["rubric_criteria_no"],
      },
      assessment_obj: {
        topic: "topic_na",
        time_spent_seconds: 0,
        question_attempted: 0,
        questions_attempted: 0,
        questions_total: 5,
        areas_of_improvement: ["areas_of_improvement_na"],
        areas_of_strengths: ["areas_of_strengths_na"],
        overall_ai_feedback_text: "overall_ai_feedback_text_na",
        completion_status: "partial",
        score: [{ ques1: 0 }, { ques2: 0 }, { ques3: 0 }, { ques4: 0 }, { ques5: 0 }],
      },
      ai_user_interaction_array: [],
      interaction: {},
      interactions: [],
      blob_uri: {
        complete_blob_uri: [],
        generated_blob_uri: [],
        uploaded_blob_uri: ["/client-recordings-artifacts/swayam/audio/"],
        downloaded_blob_uri: [],
      },
      compute_time: 0,
      tokens_used: 0,
      cache_hit: false,
      session_timeout: false,
      usage_time_in_sec: 0,
      watch_percentage: 0,
      video_duration: 0,
    },
  },
}

const InterviewAuditSlice = createSlice({
  name: "swayam_interview",
  initialState,
  reducers: {
    setAuditLogsHeartbeatStarted: (state, action: PayloadAction<boolean>) => {
      state.auditLogsHeartbeatStarted = action.payload
    },
    setAuditLogsCompleteData: (state, action: PayloadAction<any>) => {
      state.auditLogsCompleteData = action.payload
    },
    setStartEventId: (state, action: PayloadAction<string | null>) => {
      state.startEventId = action.payload
    },
    resetState: () => initialState,
  },
})

export const { resetState, setAuditLogsCompleteData, setAuditLogsHeartbeatStarted, setStartEventId } =
  InterviewAuditSlice.actions
export default InterviewAuditSlice.reducer
